/** Normalized peak above which the reactive wave UI is shown prominently. */
export const SPEAKING_LEVEL_THRESHOLD = 0.18

/** Container opacity when capture is live but below the speaking threshold. */
export const SILENT_WAVES_OPACITY = 0.2

/** Max byte frequency value used when mapping analyser bins to 0–1. */
export const FREQUENCY_PEAK_DIVISOR = 180

/** Bar height fraction when reactive mode treats the input as silent. */
export const REACTIVE_SILENT_BAR_LEVEL = 0.12

export function computePeakLevel(
  frequencyBytes: Uint8Array,
  divisor = FREQUENCY_PEAK_DIVISOR
): number {
  let peak = 0
  for (let i = 0; i < frequencyBytes.length; i++) {
    const normalized = Math.min(1, frequencyBytes[i] / divisor)
    if (normalized > peak) peak = normalized
  }
  return peak
}

/** RMS of time-domain samples (AnalyserNode byte wave), scaled to ~0–1 for mic speech. */
export function computeTimeDomainPeak(timeDomainBytes: Uint8Array): number {
  if (timeDomainBytes.length === 0) return 0
  let sumSquares = 0
  for (let i = 0; i < timeDomainBytes.length; i++) {
    const sample = (timeDomainBytes[i] - 128) / 128
    sumSquares += sample * sample
  }
  const rms = Math.sqrt(sumSquares / timeDomainBytes.length)
  return Math.min(1, rms * 4)
}

export function combineSpeechPeaks(frequencyPeak: number, timeDomainPeak: number): number {
  return Math.max(frequencyPeak, timeDomainPeak)
}

export function computeSpeakingOpacity(
  peak: number,
  threshold = SPEAKING_LEVEL_THRESHOLD,
  silentOpacity = SILENT_WAVES_OPACITY
): number {
  return peak >= threshold ? 1 : silentOpacity
}

export function clampBarLevelForReactive(
  level: number,
  peak: number,
  threshold = SPEAKING_LEVEL_THRESHOLD,
  silentLevel = REACTIVE_SILENT_BAR_LEVEL
): number {
  return peak >= threshold ? level : silentLevel
}
